import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink text-bone border-t border-gold/20 mt-32"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 pt-24 pb-10">
        {/* Big wordmark */}
        <div className="overflow-hidden">
          <h2
            className="font-serif text-bone leading-[0.85] tracking-tight"
            style={{ fontSize: "clamp(4rem, 16vw, 18rem)" }}
            data-testid="footer-wordmark"
          >
            Cine<span className="text-gold italic">.</span>Prompt
          </h2>
        </div>

        <div className="hairline mt-12 mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Manifesto blurb */}
          <div className="md:col-span-5">
            <p className="overline mb-4">Engineered for Cinema</p>
            <p className="font-serif text-2xl md:text-3xl leading-snug text-bone/90 max-w-md">
              We make pictures that feel like memories — only the memories aren't ours yet.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-collaborate"
              className="cp-btn cp-btn--glow mt-8"
            >
              Get In Touch <ArrowUpRight size={14} />
            </Link>
          </div>

          {/* Sitemap */}
          <div className="md:col-span-3">
            <p className="overline mb-5">Studio</p>
            <ul className="flex flex-col gap-3 font-sans text-bone/75 text-sm">
              <li><Link to="/" className="hover:text-gold transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/work" className="hover:text-gold transition-colors" data-testid="footer-link-work">Work</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="overline mb-5">Reach</p>
            <ul className="flex flex-col gap-3 font-sans text-bone/75 text-sm">
              <li><a href="mailto:samresh.shrivastav@gmail.com" className="hover:text-gold transition-colors" data-testid="footer-email">samresh.shrivastav@gmail.com</a></li>
              <li className="text-bone/50">Hyderabad, India</li>
            </ul>
          </div>

          {/* Social */}
          <div className="md:col-span-2">
            <p className="overline mb-5">Channels</p>
            <ul className="flex flex-col gap-3 font-sans text-bone/75 text-sm">
              <li><a href="#" className="hover:text-gold transition-colors group inline-flex items-center gap-1">Instagram <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition" /></a></li>
              <li><a href="https://youtube.com/@apocalypto22" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors group inline-flex items-center gap-1" data-testid="footer-link-youtube">YouTube <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition" /></a></li>
              <li><a href="#" className="hover:text-gold transition-colors group inline-flex items-center gap-1">Letterboxd <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition" /></a></li>
              <li><a href="#" className="hover:text-gold transition-colors group inline-flex items-center gap-1">Are.na <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition" /></a></li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-16 mb-6" />

        <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-start md:items-center justify-between text-bone/55 text-xs font-sans">
          <p data-testid="footer-copy">© 2026 Cine Prompt. All Rights Reserved.</p>
          <p className="tracking-[0.28em] uppercase text-[11px]">Made in the dark</p>
          <p className="tracking-[0.28em] uppercase text-[11px]">Engineered for Cinema</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
